












import { Component , Vue } from 'vue-property-decorator';
declare var $: any;
@Component({
    props: {
        title: String,
        message: String,
    },
})
export default class MessageBox extends Vue {

    private handleOk() {
        this.$bvModal.hide('messageModal');
        this.$emit('ok');
    }
    private showModal() {
      this.$bvModal.show('messageModal');
    }
}
